






























































































































































import queries from '@/gql/queries.coffee'

export default {
    name: 'StatsTeam',
    props: {
        consultant_uid: null
    }
    data: ()-> {}
    computed: {
        user:()->
                res = {
                    fullname: ""
                }
                res.fullname = this.$store.state.profile.data.fullname
                return res
        stats: ()->
            initialStats = 
                today:
                    received: 0
                    impossible: 0
                    redacted: 0
                    published: 0
                    signaled: 0
                    info_needed: 0
                last7days:
                    received: 0
                    impossible: 0
                    redacted: 0
                    published: 0
                    signaled: 0
                    info_needed: 0
                last30days:
                    received: 0
                    impossible: 0
                    redacted: 0
                    published: 0
                    signaled: 0
                    info_needed: 0                
            
            self = @
            
            ret = @$store.state.stats.reduce((acc, current)->
                if self.consultant_uid? and self.consultant_uid != current.consultant_id
                    return acc
                
                acc.today.received += current.today_recived_count
                acc.today.impossible += current.today_impossible_count
                acc.today.redacted += current.today_written_count
                acc.today.published += current.today_published_count
                acc.today.signaled += current.today_signaled_count
                acc.today.info_needed += current.today_information_needed_count
                acc.last7days.received += current.seven_day_recived_count
                acc.last7days.impossible += current.seven_day_impossible_count
                acc.last7days.redacted += current.seven_day_written_count
                acc.last7days.published += current.seven_day_published_count
                acc.last7days.signaled += current.seven_day_signaled_count
                acc.last7days.info_needed += current.seven_day_information_needed_count
                acc.last30days.received += current.thirty_day_impossible_count
                acc.last30days.impossible += current.thirty_day_recived_count
                acc.last30days.redacted += current.thirty_day_written_count
                acc.last30days.published += current.thirty_day_published_count
                acc.last30days.signaled += current.thirty_day_signaled_count
                acc.last30days.info_needed += current.thirty_day_information_needed_count

                return acc
               ,initialStats)
            return ret
    } 
    mounted: ()->
        self = @

}
